import { Record } from 'immutable';

const ConfigEndpointRecord = Record({
    widget: '',
    account: '',
    showroom: '',
    graphql: '',
});

class ConfigEndpointModel extends ConfigEndpointRecord {}

export default ConfigEndpointModel;



// WEBPACK FOOTER //
// ./src/models/ConfigEndpointModel.js